import type { AppEnvironment } from './types';

/**
 * Production IP4x stack. Per-domain branding (no fixed root tenant);
 * each `*.member.ip4x.systems` host resolves to its own tenant via Core
 * API. Native binaries built against this env target the regional ZA edge.
 */
export const env: AppEnvironment = {
  production: true,
  buildMode: 'ip4x',
  apiBaseUrl: 'https://ip4x-za.sudosky.com/v1',
  coreApiUrl: 'https://ip4x-core-api.sudosky.com/v1',
  appTemplateId: '',
  authMode: 'core',
  portalOwnerType: 'member',
  loadDomainConfig: true,
  defaultDomain: '',
  rootTenantId: '',
  portalBaseUrl: 'https://member.ip4x.systems',
  appName: 'Community',
  version: '1.0.0',
  appShell: 'classic',
  welcomeContent: {
    eyebrow: 'Resident companion',
    title: 'Community,\nin your pocket.',
    subtitle: 'Access and services in one place.',
  },
  communitySelectContent: {
    title: 'Choose your community',
    subtitle: 'Search for your community to continue.',
  },
  signupTermsUrl: 'https://www.glovent.co.za/terms',
};
